module.exports = __webpack_public_path__ + "static/media/IMG_7619.6c1699b2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/IMG_7619.JPG
// module id = 374
// module chunks = 0